module.exports = "/images/md.svg?19916d28fbca6861ec13f129bbd4c55c";